import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import './App.css';
import Cursor from './Cursor';
import PublicView from './views/PublicView';


const GlobalStyle = createGlobalStyle`
  body, html{
   font-family: 'Cardo', serif;
   background-color: #000000!important;
   color:#FFFFFF!important;
   overflow-x: hidden;
  }
`
function App() {

  const LoadPortfolio = () => {
    return (
      <Switch>
        <Route path='/' component={PublicView} />
      </Switch>
    );
  }

  
  return (
    <div className="App">
       <Cursor />
      <GlobalStyle />
      {LoadPortfolio()}
    </div>
  );
}

export default App;
